import { createSelector } from 'reselect'
import { orgUsersById } from 'app/modules/user/selectors'
import { UserStatus } from 'app/modules/user/constants'
import { usersByPropertyName } from 'app/modules/user/properties/selectors'
import { getDisplayName } from 'shared-web/src/helpers/CustomerHelpers'

export const usersAndProperties = createSelector([
  orgUsersById,
  usersByPropertyName,
], (usersById, usersByPropertyName) => {
  return usersById
    .valueSeq()
    .filter((user) => user.status !== UserStatus.ARCHIVED)
    .filter((user) => !user.bot)
    .map((user) => {
      return {
        user,
        installed: !!usersByPropertyName.getIn([ 'extensionInstalled', user.id, 'value' ]),
        invited: !!usersByPropertyName.getIn([ 'extensionInvited', user.id, 'value' ]),
      }
    })
    .sortBy(({ user }) => getDisplayName(user))
    .toArray()
})



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/ExtensionInviteModal/CurrentTeamMembers/selectors.js